package com.merkost.handpass.admin.auth

import androidx.compose.runtime.compositionLocalOf
import com.merkost.handpass.sharedweb.theme.ThemeMode

val LocalAdminAuth = compositionLocalOf<AuthState.LoggedIn> {
    error("No AdminAuth provided")
}

val LocalThemeSetter = compositionLocalOf<(ThemeMode) -> Unit> {
    error("LocalThemeSetter not provided")
}
